import { logX } from "../common/libs/utils";

var HTML_ESC_MAP = {
	"nbsp": " ", "iexcl": "¡", "cent": "¢", "pound": "£", "curren": "¤", "yen": "¥", "brvbar": "¦", "sect": "§", "uml": "¨", "copy": "©", "ordf": "ª", "laquo": "«", "not": "¬", "reg": "®", "macr": "¯", "deg": "°", "plusmn": "±", "sup2": "²", "sup3": "³", "acute": "´", "micro": "µ", "para": "¶", "middot": "·", "cedil": "¸", "sup1": "¹", "ordm": "º", "raquo": "»", "frac14": "¼", "frac12": "½", "frac34": "¾", "iquest": "¿", "Agrave": "À", "Aacute": "Á", "Acirc": "Â", "Atilde": "Ã", "Auml": "Ä", "Aring": "Å", "AElig": "Æ", "Ccedil": "Ç", "Egrave": "È", "Eacute": "É", "Ecirc": "Ê", "Euml": "Ë", "Igrave": "Ì", "Iacute": "Í", "Icirc": "Î", "Iuml": "Ï", "ETH": "Ð", "Ntilde": "Ñ", "Ograve": "Ò", "Oacute": "Ó", "Ocirc": "Ô", "Otilde": "Õ", "Ouml": "Ö", "times": "×", "Oslash": "Ø", "Ugrave": "Ù", "Uacute": "Ú", "Ucirc": "Û", "Uuml": "Ü", "Yacute": "Ý", "THORN": "Þ", "szlig": "ß", "agrave": "à", "aacute": "á", "acirc": "â", "atilde": "ã", "auml": "ä", "aring": "å", "aelig": "æ", "ccedil": "ç", "egrave": "è", "eacute": "é", "ecirc": "ê", "euml": "ë", "igrave": "ì", "iacute": "í", "icirc": "î", "iuml": "ï", "eth": "ð", "ntilde": "ñ", "ograve": "ò", "oacute": "ó", "ocirc": "ô", "otilde": "õ", "ouml": "ö", "divide": "÷", "oslash": "ø", "ugrave": "ù", "uacute": "ú", "ucirc": "û", "uuml": "ü", "yacute": "ý", "thorn": "þ", "yuml": "ÿ", "fnof": "ƒ", "Alpha": "Α", "Beta": "Β", "Gamma": "Γ", "Delta": "Δ", "Epsilon": "Ε", "Zeta": "Ζ", "Eta": "Η", "Theta": "Θ", "Iota": "Ι", "Kappa": "Κ", "Lambda": "Λ", "Mu": "Μ", "Nu": "Ν", "Xi": "Ξ", "Omicron": "Ο", "Pi": "Π", "Rho": "Ρ", "Sigma": "Σ", "Tau": "Τ", "Upsilon": "Υ", "Phi": "Φ", "Chi": "Χ", "Psi": "Ψ", "Omega": "Ω", "alpha": "α", "beta": "β", "gamma": "γ", "delta": "δ", "epsilon": "ε", "zeta": "ζ", "eta": "η", "theta": "θ", "iota": "ι", "kappa": "κ", "lambda": "λ", "mu": "μ", "nu": "ν", "xi": "ξ", "omicron": "ο", "pi": "π", "rho": "ρ", "sigmaf": "ς", "sigma": "σ", "tau": "τ", "upsilon": "υ", "phi": "φ", "chi": "χ", "psi": "ψ", "omega": "ω", "thetasym": "ϑ", "upsih": "ϒ", "piv": "ϖ", "bull": "•", "hellip": "…", "prime": "′", "Prime": "″", "oline": "‾", "frasl": "⁄", "weierp": "℘", "image": "ℑ", "real": "ℜ", "trade": "™", "alefsym": "ℵ", "larr": "←", "uarr": "↑", "rarr": "→", "darr": "↓", "harr": "↔", "crarr": "↵", "lArr": "⇐", "uArr": "⇑", "rArr": "⇒", "dArr": "⇓", "hArr": "⇔", "forall": "∀", "part": "∂", "exist": "∃", "empty": "∅", "nabla": "∇", "isin": "∈", "notin": "∉", "ni": "∋", "prod": "∏", "sum": "∑", "minus": "−", "lowast": "∗", "radic": "√", "prop": "∝", "infin": "∞", "ang": "∠", "and": "∧", "or": "∨", "cap": "∩", "cup": "∪", "int": "∫", "there4": "∴", "sim": "∼", "cong": "≅", "asymp": "≈", "ne": "≠", "equiv": "≡", "le": "≤", "ge": "≥", "sub": "⊂", "sup": "⊃", "nsub": "⊄", "sube": "⊆", "supe": "⊇", "oplus": "⊕", "otimes": "⊗", "perp": "⊥", "sdot": "⋅", "lceil": "⌈", "rceil": "⌉", "lfloor": "⌊", "rfloor": "⌋", "lang": "〈", "rang": "〉", "loz": "◊", "spades": "♠", "clubs": "♣", "hearts": "♥", "diams": "♦", "quot": '"', "amp": "&", "lt": "<", "gt": ">", "OElig": "Œ", "oelig": "œ", "Scaron": "Š", "scaron": "š", "Yuml": "Ÿ", "circ": "ˆ", "tilde": "˜", "ndash": "–", "mdash": "—", "lsquo": "‘", "rsquo": "’", "sbquo": "‚", "ldquo": "“", "rdquo": "”", "bdquo": "„", "dagger": "†", "Dagger": "‡", "permil": "‰", "lsaquo": "‹", "rsaquo": "›", "euro": "€"
};
var HTML_ESC_MAP_REV = {};
var HTML_ESC_CHARS = Object.keys(HTML_ESC_MAP).map(e => { let v = HTML_ESC_MAP[e]; HTML_ESC_MAP_REV[v] = e; return HTML_ESC_MAP[e] });
var HTML_ESC_MAP_DEC = new RegExp("&(" + Object.keys(HTML_ESC_MAP).join("|") + ");", "giu");
var HTML_ESC_MAP_ENC = new RegExp("(" + HTML_ESC_CHARS.join("|") + ")", "giu");

export const htmldecode = function (s) {
	return s ? s.replace(HTML_ESC_MAP_DEC, function (x) {
		return HTML_ESC_MAP[x.substring(1, x.length - 1)] || x;
	}) : s;
}

export const fromHex = function (text) {
	var arr = [];
	for (var i = 0; i < text.length; i += 2) {
		arr.push(String.fromCharCode(parseInt(text.substr(i, 2), 16)));
	}
	return arr.join('');
}

export const toHex = function (text) {
	const str = [],
		len = text.length;
	for (let i = 0; i < len; i++) {
		const c = text.charCodeAt(i);
		str.push(c.toString(16));
	}
	return str.join('');
};

export const encode_link = function (qa) {
	let s = [],
		fs = ['oname', 'pid', 'poid', 'mid', 'oid', 'uid', 'bid', 'gid', 'aid', 'rid', 'sid', 'bcid', 'ansid'];
	for (let f of fs) {
		let value = qa[f] || window.$store.state.bot[f] || window.$store.state.user[f] || '';
		if(f === 'uid' && !value) {
			value = window.$store.state.user['id'] || '';
		}
		s.push(value);
	}
	const raw = s.join(':');
	logX('Q', 'green', raw);
	return toHex(raw);
};

export const decode_link = function (qs, url, seq) {
	// qs = "66623a333a3a313235383733313234303837303531343a323a343a353a373a31333a3a";
	// qs = "fb:3::1258731240870514:2:4:5:7:13::";
	// url = "widget://checkbox";
	var fs = ['oname', 'pid', 'poid', 'mid', 'oid', 'uid', 'bid', 'gid', 'aid', 'rid', 'sid', 'bcid', 'ansid'];
	var l = fs.length;
	var ps = fromHex(qs).split(':');
	var us = url.split(':');
	var q = {
		from: 'user',
		style: us[0] == 'widget' ? 'widget' : 'linkto',
		ukey: us[0] == 'widget' ? '' : '@visit',
		uval: us[0] == 'widget' ? '' : url
	};
	for (var i = 0, f; (f = fs[i]); i++) {
		q[f] = ps[i];
	}
	// console.log(q);
	if (seq) q.rseq = seq;

	return q;
};